// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Thumbnail_wrapper__aob3l","small":"Thumbnail_small__2PYdQ","large":"Thumbnail_large__VM1v1"};